import angular from 'angular';

import * as actions from '../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
  breeds: state.pet.breeds,
  activeComponent: state.statsbar.activeComponent,
  activeTransaction: state.transaction.activeTransaction,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:ApplicationCtrl
 * @description
 * # ApplicationCtrl
 * Controller of the myConsultApp
 */

angular
  .module('myConsultApp')
  .controller(
    'ApplicationCtrl',
    function (
      $compile,
      $cookieStore,
      $localStorage,
      $window,
      $timeout,
      $rootScope,
      $route,
      $scope,
      $ngRedux,
      $http,
      AuthService,
      $location,
      IdentityService,
      Session,
      UserService,
      ATLAS_API,
      LogoutService,
      PetsService,
      OrganizationsService,
      TransactionService,
      ENV,
      redirectToUrlAfterLogin,
      utilities,
    ) {
      /*
       *  rootScope Variables
       *
       */

      $rootScope.baseUser = null;
      $rootScope.tempAccessToken = null;
      $rootScope.tempRefreshToken = null;
      $rootScope.tempExpiresIn = null;
      $rootScope.breedList = null;
      $rootScope.currentUser = UserService.currentUser ? UserService.currentUser : null;
      $rootScope.isAdminUser = UserService.isAdminUser ? UserService.isAdminUser : null;
      $rootScope.isSuperUser = UserService.isSuperUser ? UserService.isSuperUser : null;
      $rootScope.vetOrganizations = UserService.vetOrganizations
        ? UserService.vetOrganizations
        : null;
      $rootScope.currentOrganization = UserService.currentOrganization
        ? UserService.currentOrganization
        : null;
      $rootScope.isPWRSubscribed = UserService.subscriptions.isPWRSubscribed
        ? UserService.subscriptions.isPWRSubscribed
        : null;
      $rootScope.isRewardsSubscribed = UserService.subscriptions.isRewardsSubscribed
        ? UserService.subscriptions.isRewardsSubscribed
        : null;
      $rootScope.isTiggerSubscribed = UserService.subscriptions.isTiggerSubscribed
        ? UserService.subscriptions.isTiggerSubscribed
        : null;
      $rootScope.isSolensiaSubscribed = UserService.subscriptions.isSolensiaSubscribed
        ? UserService.subscriptions.isSolensiaSubscribed
        : null;
      $rootScope.isLibrelaSubscribed = UserService.subscriptions.isLibrelaSubscribed
        ? UserService.subscriptions.isLibrelaSubscribed
        : null;

      // TODO: remove this when application subscription is working
      $rootScope.adminPetId = null;
      $rootScope.adminPet = null;
      $rootScope.adminCurrentPet = null;

      $rootScope.componentOpened = false;
      $rootScope.isActionMenu = false;
      $rootScope.isPointDisplay = false;
      $rootScope.isUserPage = false;
      $rootScope.userDetailExpanded = false;

      /*
       *  Scope Variables
       *
       */
      $scope.oneTrustScriptID =
        ENV.name === 'production'
          ? '583ab69f-1204-473b-ae7b-d1ba3dce3c78'
          : '0191700e-546d-7019-ba63-57d9f682283d';
      $scope.gigyaApiScript = 'https://cdns.us1.gigya.com/js/gigya.js?apikey=' + ENV.gigyaApiKey;
      $scope.currentUser = $rootScope.currentUser ? $rootScope.currentUser : null;
      $scope.isAdminUser = $rootScope.isAdminUser ? $rootScope.isAdminUser : null;
      $scope.isSuperUser = $rootScope.isSuperUser ? $rootScope.isSuperUser : null;
      $scope.vetOrganizations = $rootScope.vetOrganizations ? $rootScope.vetOrganizations : null;
      $scope.currentOrganization = $rootScope.currentOrganization
        ? $rootScope.currentOrganization
        : null;
      $scope.isPWRSubscribed = $rootScope.isPWRSubscribed ? $rootScope.isPWRSubscribed : null;
      $scope.isRewardsSubscribed = $rootScope.isRewardsSubscribed
        ? $rootScope.isRewardsSubscribed
        : null;
      $scope.isTiggerSubscribed = $rootScope.isTiggerSubscribed
        ? $rootScope.isTiggerSubscribed
        : null;
      $scope.isSolensiaSubscribed = $rootScope.isSolensiaSubscribed
        ? $rootScope.isSolensiaSubscribed
        : null;
      $scope.isLibrelaSubscribed = $rootScope.isLibrelaSubscribed
        ? $rootScope.isLibrelaSubscribed
        : null;
      $scope.currentPet = null;
      $scope.baseUser = null;
      $scope.tempAccessToken = null;
      $scope.tempRefreshToken = null;
      $scope.tempExpiresIn = null;
      $scope.ownerPets = {};
      $scope.vetOrganizations = null;
      $scope.isAuthorized = AuthService.isAuthorized;
      $scope.isAdminRoute = false;
      $rootScope.toggleComponentAnimationDelay = 500;

      /*
       *  Scope Methods
       *
       */

      $scope.getOneTrustScriptID = () => {
        return $scope.oneTrustScriptID;
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.getUTCDateTime = function (date, format) {
        return moment(date).utc().format(format);
      };

      $scope.getUTCToLocalDateTime = function (date, format) {
        var dateUtc = moment.utc(date);
        var localDate = moment(dateUtc).local();
        return localDate.format(format);
      };

      $rootScope.clearData = () => {
        $cookieStore.remove('csrftoken');
        $cookieStore.remove('sessionid');
        Session.destroy();
        UserService.unsetOptions();
        localStorage.clear();
      };

      $rootScope.logout = () => {
        var logoutParams = {
          token: Session.accessToken,
          client_id: ATLAS_API.clientId,
        };
        LogoutService.logout(logoutParams).then(() => {
          $rootScope.clearData();
          gigya.accounts.logout();
          $timeout(() => {
            $window.location.href = '/';
          }, 300);
        });
      };

      $scope.writeTabToken = function () {
        if (Session.accessToken !== null) {
          $localStorage.tabOpened_accessToken = Session.accessToken;
          $localStorage.tabOpened_refreshToken = Session.refreshToken;
          $localStorage.tabOpened_expiresIn = Session.expiresIn;
        }
      };

      /** **************************************** */
      /* ******* Get and Set User Info *********** */
      /** **************************************** */

      $scope.checkAndGrabUserInfo = async () => {
        await UserService.checkAndGrabUserInfo().then(async (response) => {
          await $scope.setUserData(response);
        });
      };

      $scope.setUserData = async (response) => {
        $scope.currentUser = response[0];
        $scope.isAdminUser = response[1];
        $scope.isSuperUser = response[2];
        $scope.vetOrganizations = response[3];
        $scope.currentOrganization = response[4];
        $scope.isPWRSubscribed = response[5].isPWRSubscribed;
        $scope.isRewardsSubscribed = response[5].isRewardsSubscribed;
        $scope.isTiggerSubscribed = response[5].isTiggerSubscribed;
        $scope.isSolensiaSubscribed = response[5].isSolensiaSubscribed;
        $scope.isLibrelaSubscribed = response[5].isLibrelaSubscribed;
        $rootScope.baseUser = response[6];
      };

      $rootScope.addSuperUserConfig = () => {
        if (!$scope.baseUser && !$rootScope.baseUser) {
          $timeout(() => {
            $scope.baseUser = Session.getBaseUser();
            $rootScope.baseUser = $scope.baseUser;
          });
        }
      };

      $scope.$on('$routeChangeStart', async (event, current, prev) => {
        $scope.currentUser = $localStorage.currentUser
          ? $localStorage.currentUser
          : UserService.currentUser;
        $scope.isAdminUser = $localStorage.isAdminUser
          ? $localStorage.isAdminUser
          : UserService.isAdminUser;
        $scope.isSuperUser = $localStorage.isSuperUser
          ? $localStorage.isSuperUser
          : UserService.isSuperUser;
        $scope.vetOrganizations = $localStorage.vetOrganizations
          ? $localStorage.vetOrganizations
          : UserService.vetOrganizations;
        $scope.currentOrganization = $localStorage.currentOrganization
          ? $localStorage.currentOrganization
          : UserService.currentOrganization;
        $scope.isPWRSubscribed = $localStorage.subscriptions
          ? $localStorage.subscriptions.isPWRSubscribed
          : UserService.subscriptions.isPWRSubscribed;
        $scope.isRewardsSubscribed = $localStorage.subscriptions
          ? $localStorage.subscriptions.isRewardsSubscribed
          : UserService.subscriptions.isRewardsSubscribed;
        $scope.isTiggerSubscribed = $localStorage.subscriptions
          ? $localStorage.subscriptions.isTiggerSubscribed
          : UserService.subscriptions.isTiggerSubscribed;
        $scope.isSolensiaSubscribed = $localStorage.subscriptions
          ? $localStorage.subscriptions.isSolensiaSubscribed
          : UserService.subscriptions.isSolensiaSubscribed;
        $scope.isLibrelaSubscribed = $localStorage.subscriptions
          ? $localStorage.subscriptions.isLibrelaSubscribed
          : UserService.subscriptions.isLibrelaSubscribed;
        $scope.mediaId = null;
        // set isUserPage programatically at the beginning of route change
        $rootScope.isUserPage = $scope.checkIsUserPage(
          current?.$$route?.originalPath,
          prev?.$$route?.originalPath,
        );
        // flag set to determine if current route is manage-user to conditionaly display user-detail gear icon
        $rootScope.isUserRoute = Boolean(current?.$$route?.originalPath.match(/manage-users/));
      });

      /**
       * Returns true if user is entering at a manage-user page, or navigating within a manager-user page
       * @param current, next
       * @returns {*|boolean}
       */
      $scope.checkIsUserPage = (current, prev) => {
        if (!prev && current.match(/manage-users/)) {
          return true;
        }
        if (!prev) {
          return false;
        }

        if (prev.match(/manage-users/) && current.match(/manage-users/)) {
          return true;
        }

        return false;
      };

      /** **************************************** */
      /* ******* End Get and Set User Info *********** */
      /** **************************************** */


      $scope.setCurrentPet = function (pet, redirection_flag) {
        if (pet !== null) {
          if ($scope.currentPet && $scope.currentPet.id !== pet.id) {
            $scope.emptyTransactions();
          }

          PetsService.getPetProfile(pet.id).then(function (response) {
            $scope.currentPet = response;
            $rootScope.currentPet = response;
            $rootScope.$broadcast('generate-transactions');
            if (redirection_flag != false) {
              $location.path('/find-a-pet/' + response.id);
            }
          });
        } else {
          $scope.currentPet = null;
          $rootScope.currentPet = null;
          $scope.emptyTransactions();
        }
      };

      $scope.currentPetOwner = null;
      $scope.setCurrentPetOwner = function (owner) {
        $scope.currentPetOwner = owner;
      };

      $scope.changeOrganization = function (org) {
        if (org.id != $scope.currentOrganization.id) {
          // unset pet
          $scope.setCurrentPet(null);
          // change organization
          UserService.setCurrentOrganization(org);
          $scope.currentOrganization = org;
          $location.path('/');
          $route.reload();
        } else {
          $location.path('/');
          $route.reload();
        }
      };

      $scope.getOwnerPets = function (ownerId) {
        $scope.ownerPets = {};
        PetsService.getPetsByOwnerOrg(ownerId, $scope.currentOrganization.id).then(function (
          response,
        ) {
          $scope.ownerPets = response.pets;
        });
      };

      $rootScope.breedLookup = function (id) {
        var breedName = '';
        angular.forEach($scope.breedList, function (breed) {
          if (breed.id === id) {
            breedName = breed.name;
          }
        });
        return breedName;
      };
      // created for when the user comes from a redir URL then grab all the needed info
      // used also on the pet overview
      $scope.retrievingPet = false;
      $scope.retrieveMainPetInfo = function (petId) {
        $scope.retrievingPet = true;
        PetsService.getPetProfile(petId).then(
          function (response) {
            $scope.currentPet = response;
            $rootScope.currentPet = response;
            IdentityService.getUser($scope.currentPet.owner).then(function (response) {
              $scope.setCurrentPetOwner(response);
              $scope.getOwnerPets(response.id);
            });
            $scope.retrievingPet = false;
            if ($scope.vetOrganizations.length > 0) {
              // in case of multi-org user we assign the current pet organization as default
              if ($scope.currentOrganization == null) {
                OrganizationsService.getPrimaryCareProvider($scope.currentPet.id).then(function (
                  response,
                ) {
                  angular.forEach($scope.vetOrganizations, function (vetOrgs, index) {
                    if (response.organization.id == vetOrgs.id) {
                      UserService.setCurrentOrganization(vetOrgs);
                      $scope.currentOrganization = vetOrgs;
                    }
                  });
                });
              }
            }

            // call for pet-overview page
            $rootScope.$broadcast('generate-transactions');
          },
          function (response) {
            $location.path('/find-a-pet');
          },
        );
      };

      $scope.transactions = {};

      $scope.generatingTransactions = true;

      $scope.emptyTransactions = function () {
        $scope.transactions = {};
        $rootScope.transactions = $scope.transactions;
      };

      $scope.getTransactions = function () {
        if (!$scope.isAdminUser) {
          TransactionService.getTransactions(
            $scope.currentPet.id,
            $scope.currentOrganization.id,
          ).then(function (response) {
            $scope.transactions = response.transactions;
            $rootScope.transactions = $scope.transactions;
            $rootScope.petTransactionsPageData = response;
            $rootScope.petTransactions = response.transactions;
            $scope.generatingTransactions = false;
          });
        } else {
          TransactionService.getPetTransactionsAdmin(
            $scope.currentPet.id,
            $scope.currentOrganization.id,
          ).then(function (response) {
            $scope.transactions = response;
            $rootScope.transactions = $scope.transactions;
            $scope.generatingTransactions = false;
          });
        }
      };

      var cleanKey = function (key) {
        var cleanedKey = key;
        cleanedKey = cleanedKey.replace(/\s+/g, '');
        cleanedKey = cleanedKey.replace(/,/g, '');
        cleanedKey = cleanedKey.replace(/\./g, '');
        cleanedKey = cleanedKey.replace(/\//g, '');
        cleanedKey = cleanedKey.replace(/\(/g, '');
        cleanedKey = cleanedKey.replace(/\)/g, '');
        cleanedKey = cleanedKey.replace(/\:/g, '');
        cleanedKey = cleanedKey.replace(/\;/g, '');
        cleanedKey = cleanedKey.replace(/-/g, '');

        return cleanedKey;
      };

      var getChoiceByChoiceValue = function (choiceValue, question) {
        var match = {};

        angular.forEach(question.choices, function (choice) {
          if (choice.href.toString() == choiceValue.choice.toString()) {
            match = choice;
          }
        });

        return match;
      };

      // Check for application subscriptions
      $scope.subscribed = function (type, name, list) {
        var subscribed = false;
        if (!type || !name || !list) {
          return subscribed;
        }

        if (type === 'organization' && UserService.currentOrganization) {
          angular.forEach(UserService.currentOrganization.applications, function (value, key) {
            if (value.slug === name && value.is_active === true) {
              subscribed = true;
            }
          });
        }

        if (type === 'pet') {
          angular.forEach(list, function (value, key) {
            if (value.name === name) {
              subscribed = true;
            }
          });
        }

        if (type === 'petowner') {
          angular.forEach(list, function (value, key) {
            if (value.name === name) {
              subscribed = true;
            }
          });
        }

        return subscribed;
      };

      $scope.insightAnswerText = function (title) {
        var answerText = null;
        var answerTextObj = {
          'Almost done!': 'Other Information',
          'plan to travel': 'Travel Plans',
          activities: 'Activities',
          'do any of the following': 'Behavior',
          'recently had any of the following': 'Stool',
          eyes: 'Eyes',
          ears: 'Ears',
          mouth: 'Teeth/Mouth',
          'skin and coat': 'Skin/Coat',
          'Have you noticed': 'Bones/Joints',
          'shown any of the following': 'Behavior Signs',
          'following lately': 'Breathing/Digestion',
          'Have you recently noticed': 'Drinking/Urine',
        };

        for (var key in answerTextObj) {
          if (title.includes(key)) {
            // console.log(title+':'+key+ ':' +answerTextObj[key]);
            answerText = answerTextObj[key];
            break;
          }
        }
        return answerText;
      };

      /*
       *  Watchers
       *
       */

      $scope.$on('$routeChangeStart', () => {
        const path = $location.path().split('/');
        const finalParam = path.slice(-1)[0];
        const isFinalParamId = /\d/.test(finalParam);
        $(window).unbind('scroll');

        if (
          $scope.activeComponent &&
          !isFinalParamId &&
          !$rootScope.components.contains(finalParam)
        ) {
          $rootScope.closeComponent({ shouldHardClose: true });
        }
      });

      $rootScope.$on('$routeChangeSuccess', () => {
        $scope.writeTabToken();
        // add body class if admin route
        $scope.isAdminRoute = $location.url().indexOf('/admin') !== -1;
        utilities.submitTelemetry({
          event: 'e_pageData',
          orgId: $scope.currentOrganization?.id ?? null,
        });
      });

      $rootScope.$on('get-breed-list', async () => {
        if (
          ($rootScope.isAdminUser || $rootScope.isSuperUser) &&
          $rootScope.breedList &&
          $rootScope.breedList.length > 0
        ) {
          return;
        }
        await $scope.getBreeds($http, ENV);
        $rootScope.breedList = $scope.breeds;
      });

      $rootScope.$on('add-superuser-config', function () {
        // console.log('add-superuser-config');
        $rootScope.addSuperUserConfig();
      });

      $rootScope.$on('generate-transactions', function () {
        // console.log('GENERATE TRANSACTIONS');
        $scope.generatingTransactions = true;
        $scope.getTransactions();
        // console.log('transactions complete');
      });

      $scope.capitalize = (s) => {
        if (typeof s !== 'string') {
          return '';
        }
        return s.charAt(0).toUpperCase() + s.slice(1);
      };

      /** **************************************** */
      /** **************ADMIN FUNCTIONS*********** */
      /** **************************************** */

      $scope.timeout = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
      };

      $rootScope.expandUserDetailPanel = () => {
        $rootScope.userDetailExpanded = !$rootScope.userDetailExpanded;
      };

      $rootScope.components = [
        'pet-detail',
        'user-detail',
        'apply-activity',
        'apply-user-activity',
        'submit-invoice',
        'create-pet',
        'edit-pet',
        'create-organization',
        'edit-organization',
        'media-detail',
        'transaction-detail',
        'redemption-detail',
        'redeem-points',
        'point-history',
        'edit-user-profile',
        'create-activity-type',
        'edit-activity-type',
        'view-product',
        'edit-promotion-code',
        'create-promotion-code',
        'create-purchase-location',
        'edit-purchase-location',
        'create-reward',
        'edit-reward',
        'create-salesforce-import',
        'edit-salesforce-import',
        'create-ip-whitelist',
        'edit-ip-whitelist',
      ];

      $rootScope.routes = {
        'activity-type': '/admin/loyalty/activities/manage-activity-types',
        'promotion-code': '/admin/loyalty/activities/manage-promotion-codes',
        'user-activity': '/admin/loyalty/activities/manage-user-activities',
        redemption: '/admin/loyalty/reward-redemptions/manage-redemptions',
        reward: '/admin/loyalty/reward-redemptions/manage-rewards',
        transaction: '/admin/loyalty/transactions/manage-transactions',
        organization: '/admin/organizations/manage-organizations',
        pet: '/admin/pets/manage-pets',
        user: '/admin/users/manage-users',
        location: '/admin/loyalty/transactions/manage-purchase-locations',
        product: '/admin/loyalty/transactions/manage-products',
        whitelist: '/admin/third-party/ip-whitelist',
        salesforce: '/admin/reporting-database/manage-salesforce-imports',
        'story-list': '/admin/media/story-list',
        media: '/admin/media/manage-media',
        points: '/admin/loyalty/points/inaccuracies',
        // 'point-balance': '/admin/loyalty/points/manage-point-balances',
      };

      $rootScope.previousRoute = null;

      $scope.resetAuthScope = () => {
        $scope.baseUser = null;
        $rootScope.baseUser = null;
        $rootScope.baseUserId = null;
        $rootScope.currentUser = null;
        $localStorage.baseUser = null;
        $localStorage.baseUserId = null;
        $localStorage.currentUser = null;
        Session.resetBaseTokens(
          $scope.tempAccessToken,
          $scope.tempRefreshToken,
          $scope.tempExpiresIn,
        );
        $rootScope.$broadcast('get-breed-list');
        redirectToUrlAfterLogin.url = '/';

        $scope.tempAccessToken = null;
        $rootScope.tempAccessToken = null;
        $scope.tempRefreshToken = null;
        $rootScope.tempRefreshToken = null;
        $scope.tempExpiresIn = null;
        $rootScope.tempExpiresIn = null;
        UserService.currentUser = null;
      };

      $scope.resetToSuperuser = function () {
        $scope.resetAuthScope();
        $scope.checkAndGrabUserInfo();
      };

      $scope.setTemporaryUser = function () {
        $scope.tempAccessToken = Session.accessToken;
        $rootScope.tempAccessToken = Session.accessToken;
        $scope.tempRefreshToken = Session.refreshToken;
        $rootScope.tempRefreshToken = Session.refreshToken;
        $scope.tempExpiresIn = Session.expiresIn;
        $rootScope.tempExpiresIn = Session.expiresIn;
        $scope.baseUser = $scope.currentUser;
        $rootScope.baseUser = $rootScope.currentUser;
        $localStorage.baseUser = $scope.currentUser;
        Session.setBaseTokens(
          $scope.tempAccessToken,
          $scope.tempRefreshToken,
          $scope.tempExpiresIn,
          $scope.currentUser.id,
        );
      };

      $scope.checkAdminAuth = async (reload) => {
        var error = false;
        await UserService.checkAdminAuth().then(async (response) => {
          console.log(response);
          if (response[1] || response[2]) {
            await $scope.setUserData(response);
            if (reload) {
              $route.reload();
              $location.path('/admin');
            }
          } else {
            await $scope.setUserData(response);
            if (response[3] && response[3].length > 0) {
              if (reload) {
                $route.reload();
                if (
                  (response[5].isTiggerSubscribed ||
                    response[5].isSolensiaSubscribed ||
                    response[5].isLibrelaSubscribed) &&
                  response[5].isRewardsSubscribed
                ) {
                  $location.path('/');
                } else if (response[5].isTiggerSubscribed) {
                  $location.path('/catpainiq');
                } else if (response[5].isSolensiaSubscribed) {
                  $location.path('/experience-solensia');
                } else if (response[5].isLibrelaSubscribed) {
                  $location.path('/experience-librela');
                } else if (response[5].isRewardsSubscribed) {
                  $location.path('/rewards');
                } else {
                  $location.path('/');
                }
              }
            } else {
              await $scope.resetAuthScope();
              error = true;
            }
          }
        });
        if (!error) {
          return true;
        }
        return false;
      };

      $scope.checkPermission = (user, id) => {
        return user.some((item) => item.id === id);
      };

      $rootScope.onDisplayPoints = (id) => {
        const closeRoute = `${$rootScope.routes.user}/${id}`;
        const onBefore = () => {
          $rootScope.isPointDisplay = true;
        };
        const onClose = () => {
          $rootScope.isPointDisplay = false;
        };
        const beforeRoute = `${$rootScope.routes.user}/${id}/point-history`;

        const componentOptions = {
          component: 'point-history',
          onBefore: onBefore,
          onClose: onClose,
          beforeRoute: beforeRoute,
          closeRoute: closeRoute,
        };
        $rootScope.openComponent(componentOptions);
      };

      $rootScope.onCreatePet = () => {
        const componentOptions = {
          component: 'create-pet',
          onBefore: () => $rootScope.clearAdminPet(),
        };
        $rootScope.openComponent(componentOptions);
      };

      $scope.onSelectPet = ({ petId, beforeRoute, closeRoute }) => {
        if (!petId) return;
        const onBefore = () => {
          $rootScope.adminPetId = petId;
        };
        const beforeRouteOption =
          beforeRoute ||
          ($rootScope.isUserRoute
            ? `${$rootScope.routes.user}/${$rootScope.userId}/pet-detail/${petId}`
            : `${$rootScope.routes.pet}/pet-detail/${petId}`);
        const closeRouteOption = closeRoute || $rootScope.previousRoute || $rootScope.routes.pet;
        const componentOptions = {
          component: 'pet-detail',
          onBefore: onBefore,
          beforeRoute: beforeRouteOption,
          closeRoute: closeRouteOption,
        };
        $rootScope.openComponent(componentOptions);
      };

      $scope.onEditPet = ({ petId, beforeRoute, closeRoute }) => {
        if (!petId) return;
        const onBefore = () => {
          $rootScope.adminPetId = petId;
        };
        const closeRouteOption = closeRoute || $rootScope.previousRoute || $rootScope.routes.pet;
        const componentOptions = {
          component: 'edit-pet',
          onBefore: onBefore,
          closeRoute: closeRouteOption,
          beforeRoute: beforeRoute || `${$rootScope.routes.pet}/${petId}`,
        };
        $rootScope.openComponent(componentOptions);
      };

      $scope.onCreateOrganization = () => {
        $scope.organizationId = null;
        $scope.organization = null;
        $rootScope.openComponent({ component: 'create-organization' });
      };

      $scope.onEditOrganization = ({ organizationId, beforeRoute, closeRoute }) => {
        if (!organizationId) return;

        $scope.getOrganization($http, ENV, organizationId).then(
          () => {
            const onBefore = () => {
              $scope.container_class = 'edit-organization-container';
            };
            const closeRouteOption =
              closeRoute || $rootScope.previousRoute || $rootScope.routes.organization;
            const componentOptions = {
              component: 'edit-organization',
              onBefore: onBefore,
              closeRoute: closeRouteOption,
              beforeRoute: beforeRoute || `${$rootScope.routes.organization}/${organizationId}`,
            };
            $rootScope.openComponent(componentOptions);
          },
          () => {
            $scope.showErrorModal = true;
            $scope.errorModalOptions = {
              heading: 'Organization Error',
              message: `${organizationId} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
              buttons: [
                {
                  label: 'Close',
                  href: '#',
                  clickFn: () => {
                    $scope.showErrorModal = false;
                  },
                },
              ],
            };
          },
        );
      };

      $scope.showMediaDetail = ({ media, beforeRoute, closeRoute, userId }) => {
        if (!media) {
          $scope.setActiveMedia(null);
          return;
        }

        const closeRouteOption = closeRoute || $rootScope.previousRoute || $rootScope.routes.media;
        const onBefore = async () => {
          if (userId || media?.user?.id) $rootScope.userId = userId;
          if (media?.length > 1) {
            $scope.setActiveMedia(media);
          } else {
            if (media.length === 1) media = media[0];
            await $scope.getMediaInfo($http, ENV, media.id).then((response) => {
              $scope.userId = response.user.id;
              $scope.mediaId = response.id;
              $scope.adminPetId = response.pets?.[0]?.id;
            });
          }
        };
        const onClose = () => {
          $scope.setActiveMedia(null);
        };
        const componentOptions = {
          component: 'media-detail',
          onBefore: onBefore,
          onClose: onClose,
          closeRoute: closeRouteOption,
          beforeRoute: beforeRoute,
        };
        $rootScope.openComponent(componentOptions);
      };

      $scope.showJourneyDetail = (journeyRecord) => {
        $scope.setActiveJourney(journeyRecord);
      };

      /**
       * Open UI component (all component opens should use this function and not setActiveComponent Directly)
       * Passes through onBefore and onClose hook functions
       * DO NOT CHANGE LOCATION IN onClose(), location needs to be passed in closeRoute
       *
       * @param {string} component - the name of the component to be displayed
       * @param {function} onBefore - onBefore function to be called by setActiveComponent hook
       * @param {function} onClose - onBefore function to be called by setActiveComponent hook
       * @param {string} beforeRoute - route to set URL location to prior to opening component
       * @param {string} closeRoute - onBefore function to be called by setActiveComponent hook
       * @returns {Promise}
       */

      $rootScope.openComponent = ({ component, onBefore, onClose, beforeRoute, closeRoute }) => {
        return new Promise((resolve, reject) => {
          if (!component || $scope?.activeComponent === component) return;

          // if there is already a component opened, wait for it to close by setting delay
          let delay = 0;
          if ($scope.activeComponent) {
            delay = $rootScope.toggleComponentAnimationDelay;
          }

          // pass through onBefore/onClose functions and closeRoute
          const componentOptions = {
            onBefore: typeof onBefore === 'function' && onBefore,
            onClose: typeof onClose === 'function' && onClose,
            closeRoute: closeRoute,
          };

          $timeout(() => {
            $scope
              .setActiveComponent(component, componentOptions)
              .then(() => {
                $('.admin-overlay').css({ display: 'block' });
                const reloadRoute = false; // TODO: determine wether route should be reloaded
                $rootScope.userDetailExpanded = false;
                $rootScope.componentOpened = true; // TODO: this var should be refactored out in the future
                if (beforeRoute) $location.path(beforeRoute, reloadRoute);
                resolve(true);
              })
              .catch((error) => {
                reject(error);
              });
          }, delay);
        });
      };

      /**
       * Close open UI component ()
       *
       * @param {string} shouldHardClose - flag to immedialy close component and ignore closeRoute location change
       * @returns {Promise}
       */

      $rootScope.closeComponent = ({ shouldHardClose = false } = {}) => {
        return new Promise((resolve, reject) => {
          const delay = shouldHardClose ? 0 : $rootScope.toggleComponentAnimationDelay;
          $('.component-wrapper').removeClass('expanded');
          $('.admin-overlay').css({ display: 'none' });

          // if shouldHardClose unset user, pet, organization
          if (shouldHardClose) {
            $rootScope.userId = null;
            $rootScope.adminPetId = null;
            $rootScope.currentOrganization = null;
          }
          $timeout(() => {
            $scope
              .setActiveComponent('') // setActiveComponent promise will return closeRoute location
              .then((closeRoute) => {
                if (!shouldHardClose) {
                  $location.path(closeRoute, false);
                }
                $rootScope.componentOpened = false;
                $rootScope.isPointDisplay = false;
                $rootScope.userDetailExpanded = false;
                resolve(true);
              })
              .catch((error) => {
                reject(error);
              });
          }, delay);
        });
      };

      $scope.showTransactionDetail = ({ transactionId, beforeRoute, closeRoute }) => {
        // open transaction-detail component if transaction is valid
        $scope.getTransaction($http, ENV, transactionId).then(
          (response) => {
            const onBefore = () => {
              $rootScope.userId = response.user.id;
            };
            const onClose = () => {
              $scope.clearTransaction();
            };
            const closeRouteOption =
              closeRoute || $rootScope.prevousRoute || $rootScope.routes.transaction;
            const componentOptions = {
              component: 'transaction-detail',
              onBefore: onBefore,
              onClose: onClose,
              closeRoute: closeRouteOption,
              beforeRoute: beforeRoute || `${$rootScope.routes.transaction}/${transactionId}`,
            };
            $rootScope.openComponent(componentOptions);
          },
          () => {
            $scope.showErrorModal = true;
            $scope.errorModalOptions = {
              heading: 'Transaction Error',
              message: `${transactionId} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
              buttons: [
                {
                  label: 'Close',
                  href: '#',
                  clickFn: () => {
                    $scope.showErrorModal = false;
                  },
                },
              ],
            };
          },
        );
      };

      $scope.showRedemptionDetail = ({ redemptionId, beforeRoute, closeRoute }) => {
        // open redemption-detail component if redemption is valid
        $scope.getRedemption($http, ENV, redemptionId).then(
          (response) => {
            const onBefore = () => {
              $rootScope.userId = response.user.id;
            };
            const onClose = () => {
              $scope.clearRedemption();
            };
            const closeRouteOption =
              closeRoute || $rootScope.prevousRoute || $rootScope.routes.redemption;
            const componentOptions = {
              component: 'redemption-detail',
              onBefore: onBefore,
              onClose: onClose,
              closeRoute: closeRouteOption,
              beforeRoute: beforeRoute || `${$rootScope.routes.redemption}/${redemptionId}`,
            };
            $rootScope.openComponent(componentOptions);
          },
          () => {
            $scope.showErrorModal = true;
            $scope.errorModalOptions = {
              heading: 'Redemption Error',
              message: `${redemptionId} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
              buttons: [
                {
                  label: 'Close',
                  href: '#',
                  clickFn: () => {
                    $scope.showErrorModal = false;
                  },
                },
              ],
            };
          },
        );
      };

      $rootScope.toggleErrorModal = (options) => {
        $rootScope.showErrorModal = !$rootScope.showErrorModal;
        $rootScope.errorModalOptions = options || null;
      };

      $scope.hideModal = async () => {
        await angular.element(document.querySelector('.admin-modal')).removeClass('display');
        angular.element(document.querySelector('.admin-overlay-modal')).remove();
        setTimeout(() => {
          angular.element(document.querySelector('.admin-modal')).remove();
        }, 500);
      };

      $rootScope.clearAdminPet = () => {
        $rootScope.adminPetId = null;
        $rootScope.adminPet = null;
        $rootScope.adminCurrentPet = null;
      };

      $rootScope.refreshAdminPet = (petId) => {
        $scope.getPet($http, ENV, petId).then((res) => {
          $scope.$apply(() => {
            $rootScope.adminPet = res;
            $rootScope.userId = res.owner;
            $rootScope.adminCurrentPet = angular.copy($rootScope.adminPet);
          });
        });
      };

      const userListener = $rootScope.$watch('userId', async () => {
        // get new user only if userId exists and is different from activeUser.id
        if ($rootScope.userId && $rootScope.userId !== $scope.user.id) {
          $scope.getUser($http, ENV, $rootScope.userId); // getUser action calls getUserPets action
          $scope.getLoyaltyStatistics($http, ENV, $rootScope.userId);
        } else if ($rootScope.userId && $rootScope.userId === $scope.user.id) {
          $scope.setActiveJourney(null);
          $rootScope.userDetailExpanded = false;
          $scope.getLoyaltyStatistics($http, ENV, $rootScope.userId);
        } else if (!$rootScope.isUserPage || $rootScope.userId === null) {
          $scope.setActiveUser({});
          $scope.setActiveUserInfo({});
          $scope.setActiveJourney(null);
          $scope.setUserPets([]);
          $scope.clearRedemption();
          $rootScope.userDetailExpanded = false;
        }
      });

      const orgListener = $rootScope.$watch('currentOrganization.id', (organizationId) => {
        if (organizationId) $scope.getOrganizationStatistics({ $http, ENV, organizationId });
      });

      const adminPetIdListener = $rootScope.$watch('adminPetId', () => {
        if ($rootScope.adminPetId) {
          $rootScope.refreshAdminPet($rootScope.adminPetId);
        } else {
          $rootScope.clearAdminPet();
        }
      });

      $scope.triggerInput = (id, val) => {
        const e = document.getElementById(`${id}_value`);
        if (e) {
          e.value = val;
          angular.element(e).triggerHandler('input');
        }
      };

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        userListener();
        orgListener();
        adminPetIdListener();
      });
    },
  );
